import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const colorPalettes = {
  normal: {
    primary: '#1976d2',
    secondary: '#9e9e9e',
    error: '#d32f2f',
    warning: '#ed6c02',
    info: '#0288d1',
    success: '#2e7d32',
  },
  protanopia: {
    primary: '#0072B2',
    secondary: '#999999',
    error: '#882255',
    warning: '#F0E442',
    info: '#56B4E9',
    success: '#44AA99',
  },
  deuteranopia: {
    primary: '#0072B2',
    secondary: '#a0a0a0',
    error: '#D55E00',
    warning: '#E69F00',
    info: '#56B4E9',
    success: '#44AA99',
  },
  tritanopia: {
    primary: '#44AA99',
    secondary: '#a6a6a6',
    error: '#CC79A7',
    warning: '#E69F00',
    info: '#005C7A',
    success: '#228B22',
  },
  achromatopsia: {
    primary: '#999999',
    secondary: '#666666',
    error: '#111111',
    warning: '#888888',
    info: '#888888',
    success: '#555555',
  },
};

export type ColorBlindnessType =
  | 'normal'
  | 'protanopia'
  | 'deuteranopia'
  | 'tritanopia'
  | 'achromatopsia';

interface ThemeState {
  currentTheme: ColorBlindnessType;
}

const initialState: ThemeState = {
  currentTheme: 'normal',
};

const slice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeType: (state, action: PayloadAction<ColorBlindnessType>) => {
      state.currentTheme = action.payload;
    },
    resetTheme: (state) => {
      state.currentTheme = 'normal';
    },
  },
});

const themePersistConfig = {
  key: 'accessibility',
  storage,
};

export default persistReducer(themePersistConfig, slice.reducer);

export const {
  setThemeType,
  resetTheme,
} = slice.actions;

export const selectCurrentTheme = (state: { theme: ThemeState }) => state.theme.currentTheme;
export const selectThemeState = (state: { theme: ThemeState }) => state.theme;
export const selectCurrentPalette = (state: { theme: ThemeState }) => {
  const { currentTheme } = state.theme;
  return colorPalettes[currentTheme];
};